<template>
  <div>
    <LHeaderContacts>
      <LNav />
    </LHeaderContacts>
    <section class="container contacts">
      <div class="row">
        <div class="col-12 top">
          <h3>{{ t('contacts.title') }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="container">
          <div class="row">
            <div class="col-12 content">
              <div class="row">
                <div class="col-xl-5 info">
                  <div class="row">
                    <div class="col-12 cont adress">
                      <div class="icon">
                        <img imgproxy-src="https://leonhotel.ru/img/icons/geo.svg" alt="Location icon" />
                      </div>
                      <div class="text">
                        <p>{{ t('contacts.address') }}</p>
                      </div>
                    </div>
                    <div class="col-12 cont">
                      <div class="icon">
                        <img imgproxy-src="https://leonhotel.ru/img/icons/phone.svg" alt="Phone icon" />
                      </div>
                      <div class="text">
                        <p>{{ t('contacts.phones') }}</p>
                      </div>
                    </div>
                    <div class="col-12 cont">
                      <div class="icon">
                        <img imgproxy-src="https://leonhotel.ru/img/icons/food.svg" alt="Food delivery icon" />
                      </div>
                      <div class="text">
                        <p>{{ t('contacts.delivery') }}</p>
                      </div>
                    </div>
                    <div class="col-12 cont">
                      <div class="icon">
                        <img imgproxy-src="https://leonhotel.ru/img/icons/mail.svg" alt="Email icon" />
                      </div>
                      <div class="text">
                        <p>leon-hotel@mail.ru</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-7 map">
                  <iframe
                    src="https://yandex.ru/map-widget/v1/?um=constructor%3A9f0c370c6b2d7416ba80c41a25241bb7437858b61a6501826539205ab88b8cfe&amp;source=constructor"
                    width="100%" height="396" frameborder="0" :title="$t('contacts.mapTitle')"></iframe>
                </div>
              </div>
            </div>
            <div class="borders b-d-left b-d-right b-d-bottom"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="container contacts" v-if="vacancy.length > 0" id="vacancy">
      <div class="row">
        <div class="col-12 top">
          <h3>{{ t('vacancy.title') }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="container">
          <div class="row">
            <div class="col-12 content">
              <div class="col-12">
                <div class="col-12">
                  <div class="col-12">
                    <div class="row vacans" v-for="item in vacancy" :key="item._id">
                      <div class="col-12">
                        <div class="col-12 type_name">
                          <h5>{{ item.name }}</h5>
                        </div>
                      </div>
                      <div class="col-xl-7 col-12">
                        <div class="treb">
                          <div class="col-lg-2 col-md-3 col-12">
                            <b class="b_color">{{ t('vacancy.requirements') }}</b>
                          </div>
                          <div class="col-lg-10 col-md-9 col-12">
                            <p>{{ item.requirements }}</p>
                          </div>
                        </div>
                        <div class="objazan">
                          <div class="col-lg-2 col-md-3 col-12">
                            <b class="b_color">{{ t('vacancy.duties') }}</b>
                          </div>
                          <div class="col-lg-10 col-md-9 col-12">
                            <p>{{ item.conditions }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-5 col-12 uslov">
                        <div class="col-12">
                          <b class="b_color">{{ t('vacancy.conditions') }}</b>
                          <p>{{ item.responsibilities }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="borders b-d-left b-d-right b-d-bottom"></div>
          </div>
        </div>
      </div>
    </section>
    <LFooter />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// SEO optimization
useHead({
  title: 'Контакты отеля LEON - Как нас найти в Сухуме, Абхазия',
  meta: [
    {
      name: 'description',
      content: 'Контактная информация отеля LEON в Сухуме: адрес, телефоны, электронная почта. Расположение на карте, схема проезда и координаты для GPS.'
    },
    {
      name: 'keywords',
      content: 'контакты отеля леон, адрес отеля в сухуме, телефон отеля, email отеля, как добраться, расположение, карта, координаты'
    },
    {
      property: 'og:title',
      content: 'Контакты отеля LEON - Как нас найти в Сухуме, Абхазия'
    },
    {
      property: 'og:description', 
      content: 'Контактная информация отеля LEON в Сухуме: адрес, телефоны, электронная почта. Расположение на карте, схема проезда и координаты для GPS.'
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:image',
      content: '/img/contacts-main.jpg'
    },
    {
      property: 'og:url',
      content: 'https://leonhotel.ru/contacts'
    }
  ]
})

definePageMeta({
  layout: 'default'
})

const { data: vacancy } = useLazyAsyncData('vacancy', () => $fetch('https://api.leonhotel.ru/api/v1/vacancy'), { default: () => [] })
</script>

<i18n lang="json">
{
  "en": {
    "contacts": {
      "title": "Contacts",
      "address": "Hotel-restaurant Leon, Republic of Abkhazia,\nSukhum, 6 Chitanava St.",
      "phones": "+7 (940) 962-11-00\n+7 (940) 720-11-00\n+7 (840) 228-81-11",
      "delivery": "Delivery / restaurant:\n+7 (940) 707-11-00",
      "mapTitle": "Hotel location map"
    },
    "vacancy": {
      "title": "Vacancies",
      "requirements": "Requirements",
      "duties": "Duties",
      "conditions": "Conditions"
    }
  },
  "ru": {
    "contacts": {
      "title": "Контакты",
      "address": "Отель-ресторан Леон, Республика Абхазия,\nг. Сухум, Читанава 6",
      "phones": "+7 (940) 962-11-00\n+7 (940) 720-11-00\n+7 (840) 228-81-11",
      "delivery": "Доставка / ресторан:\n+7 (940) 707-11-00",
      "mapTitle": "Карта расположения отеля"
    },
    "vacancy": {
      "title": "Вакансии",
      "requirements": "Требования",
      "duties": "Обязанности",
      "conditions": "Условия"
    }
  }
}
</i18n>

<style scoped>
@media screen and (min-width: 1300px) {
  .map {
    padding-right: 69px;
  }
}

.contacts {
  margin-top: 50px;
  margin-bottom: 50px;
}

.top {
  flex: 0 0 calc(100% - 88px);
  border-left: 2px solid #d9ccaf;
  border-right: 2px solid #d9ccaf;
  border-top: 2px solid #d9ccaf;
  padding-left: 111px;
  padding-right: 111px;
  margin-left: 44px;
  margin-right: 44px;
  padding-bottom: 20px;
}

.top h3 {
  margin-left: auto;
  margin-right: auto;
  margin-top: -25px;
  font-family: "Didot";
  font-size: 40px;
  background-color: white;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 2px;
  line-height: 1;
  width: 204px;
}

.content {
  position: relative;
  padding-bottom: 35px;
  width: 100%;
}

.container .row {
  position: relative;
  z-index: 2;
}

.container .row .borders {
  position: absolute;
  left: 44px;
  right: 44px;
  bottom: 0;
  top: 0;
  z-index: 1;
}

.b-d-top {
  border-top: 2px solid #d9ccaf !important;
}

.b-d-bottom {
  border-bottom: 2px solid #d9ccaf !important;
}

.b-d-right {
  border-right: 2px solid #d9ccaf !important;
}

.b-d-left {
  border-left: 2px solid #d9ccaf !important;
}

.cont {
  position: relative;
  padding-left: 69px;
  margin-top: 32px;
}

.cont div {
  float: left;
}

.cont div.icon {
  margin-right: 11px;
  width: 40px;
  height: 40px;
  display: flex;
}

.cont div.icon img {
  margin: auto;
  margin-top: 3.5px;
}

.cont div.text p {
  font-family: "Lato";
  font-size: 20px;
  line-height: 27px;
}

.cont div.text p:first-child {
  margin-top: -3.5px;
}

.cont:last-child div.text p {
  margin-top: 4px;
}

.treb p,
.uslov p,
.objazan p {
  font-family: "Lato";
  font-size: 20px;
  line-height: 27px;
  margin-bottom: 15px !important;
}

.b_color {
  color: #9d9566;
  font-size: 24px;
  margin-bottom: 15px;
  display: block;
}

.type_name h5 {
  font-family: "Didot";
  font-size: 28px;
  line-height: 1;
  margin-top: 0px !important;
  margin-bottom: 15px !important;
  font-weight: bold;
}

.vacans {
  margin-top: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #d9ccaf !important;
}

.vacans:last-child {
  border-bottom: 0px solid #d9ccaf !important;
  padding-bottom: 0px;
}

.vacans.row {
  margin-left: -17px;
  margin-right: -17px;
}

.vacans:first-child {
  margin-top: 0;
}

@media screen and (max-width: 1200px) {
  .top {
    padding-left: 0;
    padding-right: 0;
  }

  .top h3 {
    margin-top: -25px !important;
  }

  .cont div {
    max-width: 207px;
  }

  .adress {
    margin-top: 0px !important;
  }

  .info {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 425px) {
  .cont {
    padding-left: 56px;
  }

  .cont div.text p {
    font-size: 16px;
  }

  .cont div.icon {
    margin-right: 30px;
    width: 26px;
    height: 26px;
  }
}

@media screen and (max-width: 375px) {
  .cont div {
    max-width: 188px;
  }

  .cont div.text p {
    font-size: 16px;
  }

  .cont div.icon {
    margin-right: 30px;
    width: 20px;
    height: 20px;
  }
}
</style>
